export * from './pdfgenerator-corte.service';